import { axios } from '@/utils/request'

export function fetchList (params) {
  return axios({
    url: '/projectCuringInfo/page',
    method: 'GET',
    params: {
      ...params
    }
  })
}

export function delObj (id) {
  return axios({
    url: `/projectCuringInfo/${id}`,
    method: 'DELETE'
  })
}
export function getObj (id) {
  return axios({
    url: `/projectCuringInfo/${id}`,
    method: 'GET'
  })
}
export function addObj (params) {
  return axios({
    url: `/projectCuringInfo/save`,
    method: 'POST',
    data: {
      ...params
    }
  })
}
export function putObj (params) {
  return axios({
    url: `/projectCuringInfo/update`,
    method: 'POST',
    data: {
      ...params
    }
  })
}